module.exports = __webpack_public_path__ + "media/icon_transaction/rabit_3-e2713e48.png";